import { apiBackOffice, apiRoteirizacao } from "./utils/api";
import { clientBackOffice, clientRoteirizacao } from "./utils/request";



export const salvarVisita = async (camposVisita) => {
  if (!navigator.onLine) return null;

  try {
    const res = await clientRoteirizacao.post(`/api/Visita`, camposVisita);
    return res.data;
  } catch (error) {
    clientBackOffice.post(`/api/LogErro`, {
      url: `/api/Visita`,
      metodo: 'POST',
      payload: JSON.stringify(camposVisita),
      status: `${error.response?.status || 'sem status'}`,
      resposta: JSON.stringify(error.response?.data) || 'sem resposta',
      stack: error.stack || 'sem stack',
    });
    throw error;
  }
};


export const salvarVisitas = async (camposVisita) => {
  if (!navigator.onLine) {
    return null;
  }

  try {
    const response = await clientRoteirizacao.post(`/api/Visita/Todas`, camposVisita);
    return response.data;
  } catch (error) {
    const responseLog = await clientBackOffice.post(`/api/LogErro`, {
      url: `/api/Visita/Todas`,
      metodo: 'POST',
      payload: JSON.stringify(camposVisita),
      status: error.response?.status || 'sem status',
      resposta: JSON.stringify(error.response?.data) || 'sem resposta',
      stack: error.stack || 'sem stack',
    });
  }
};

export const getMissao = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Missao/${id}`).then((response) => response);
  return res;
}

export const getInfoTatica = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/InfoTatica/${id}`).then((response) => response);
  return res;
}